export const getRankChartPreviewUrl = (department, season, mode, selectedWeightIds = null) => {
  // A noopener tab has its own session storage. Carry the full Rank context so
  // DepartmentWrapper can validate and restore it through the authorized lookup.
  const query = new URLSearchParams({
    pk_Department: department.pk_Department,
    pk_Season: season.pk_Season,
    mode,
  });

  if (Array.isArray(selectedWeightIds)) {
    query.set('weightIds', selectedWeightIds.join(','));
  }

  return `/administrator/rank/chart_print_preview?${query.toString()}`;
};

export const getRequestedWeightIds = (search = '') => {
  const query = new URLSearchParams(search);
  if (!query.has('weightIds')) {
    return null;
  }

  return query
    .get('weightIds')
    .split(',')
    .filter((weightId) => weightId !== '');
};
